<template>
  <!-- <TextBlob v-if="loading">
      <template #text>
        <PulseLoader />
      </template>
    </TextBlob> -->
  <!-- <div v-if="reviews.length > 0"> -->
  <div>
    <TextBlob class="hidden" headingSize="s">
      <!-- lets put our logo in the top right and have the client's name here in the heading below -->
      <template #heading> Review Metrics </template>
      <template #text>
        <PulseLoader v-if="loading" />
        <el-table v-else :data="reviews">
          <el-table-column prop="reviewerId.email" label="Email" width="300" />
          <el-table-column prop="rating" label="Rating" width="100" />
          <el-table-column prop="comment" label="Comment">
            <template #default="{ row }">
              <span v-if="row.comment">{{ row.comment }}</span>
              <span v-else>None</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </TextBlob>
    <div class="w-full hidden">
      <div class="md:w-1/2 mx-auto flex flex-col md:flex-row justify-center">
        <TextBlob blobSize="full" headingSize="s">
          <template #heading> Created Reviewers </template>
          <template #text>
            <el-table :data="reviews">
              <el-table-column prop="email" label="Email" width="300" />
              <el-table-column
                prop="createdAt"
                label="Created At"
                width="100"
              />
            </el-table>
          </template>
        </TextBlob>
        <TextBlob blobSize="full" headingSize="s">
          <template #heading> Reviewer Actions </template>
          <template #text>
            <el-table :data="reviews">
              <el-table-column prop="email" label="Email" width="300" />
              <el-table-column prop="activity" label="Activity" width="100" />
            </el-table>
          </template>
        </TextBlob>
      </div>
    </div>
    <ExtendedDashboard v-if="userStore.showExtended" />
    <TextBlob class="mt-8" blobSize="l" headingSize="s">
      <template #heading> Overview </template>
      <template #text>
        <div class="w-full">
          <el-table class="large-font-table w-full" :data="[overviewData]">
            <el-table-column
              prop="reviewersWithStatusReviewed"
              label="Reviews Received"
              min-width="33%"
              header-align="center"
              align="center"
            >
              <div class="large-font-column">
                {{ reviewersWithStatusReviewed }}
              </div>
            </el-table-column>
            <el-table-column
              prop="choiceReviewButtonClickedYes"
              label="Clicked Link to Public Review"
              min-width="33%"
              header-align="center"
              align="center"
            >
              <div class="large-font-column">
                <span class="text-green-500">{{
                  choiceReviewButtonClickedYes
                }}</span>
              </div>
            </el-table-column>
            <el-table-column
              prop="choiceReviewButtonClickedNo"
              label="Declined Leaving Public Review"
              min-width="33%"
              header-align="center"
              align="center"
            >
              <div class="large-font-column">
                <span class="text-red-500">{{
                  choiceReviewButtonClickedNo
                }}</span>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </TextBlob>
    <TextBlob class="mt-8" headingSize="s">
      <template #heading> Analytics </template>
      <template #text>
        <PulseLoader v-if="loading" />
        <div v-else-if="reviews.length == 0" class="text-center">
          No reviews to display yet. Send out a review link to get started!
        </div>
        <div v-else class="flex flex-col md:flex-row">
          <div class="w-full md:w-1/3">
            <el-table :data="analytics">
              <el-table-column prop="name" label="Metric" fixed width="200" />
              <el-table-column prop="value" label="Value" width="100" />
            </el-table>
          </div>
          <!-- <PieChart :data="reviews" class="w-full" title="Ratings Breakdown" /> -->

          <BarChart class="w-full md:w-2/3" :data="reviews" title="Ratings" />
        </div>
      </template>
    </TextBlob>

    <TextBlob class="hidden" headingSize="text-3xl">
      <template #heading> Charts </template>
      <template #text>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
          <BarChart :data="reviews" title="Ratings" class="min-h-[100px]" />
          <PieChart :data="reviews" title="Ratings Breakdown" />
          <!-- <TreeChart :data="reviews" title="Comment Length" /> -->
          <!-- <RadialChart :data="reviews" title="Response Time"/> -->
          <!-- <BubbleChart :data="reviews" title="Ratings vs Time" /> -->
          <!-- <AreaChart :data="reviews" title="Reviews vs Time" /> -->
        </div>
      </template>
    </TextBlob>
  </div>
  <div>
    <TextBlob class="mt-8" headingSize="s">
      <template #heading> Review Metrics </template>
      <template #text>
        <div class="text-center">Coming Soon...</div>
      </template>
    </TextBlob>
  </div>
</template>

<script setup>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ref, computed } from "vue";
import TextBlob from "@/components/TextBlob.vue";
import { ElTable, ElTableColumn } from "element-plus";
import api from "@/composables/api";
import BarChart from "@/components/charts/BarChart.vue";
import PieChart from "@/components/charts/PieChart.vue";
import ExtendedDashboard from "./components/extended/ExtendedDashboard.vue";
// import TreeChart from "@/components/charts/TreeChart.vue";
// import RadialChart from "@/components/charts/RadialChart.vue";
// import BubbleChart from "@/components/charts/BubbleChart.vue";
// import AreaChart from "@/components/charts/AreaChart.vue";
import { useUser } from "@/stores";
const userStore = useUser();
const loading = ref(true);

const reviews = ref([]);
const choiceReviewButtonClickedYes = ref(0);
const choiceReviewButtonClickedNo = ref(0);
const reviewersWithStatusReviewed = ref(0);

const overviewData = computed(() => ({
  reviewersWithStatusReviewed: reviewersWithStatusReviewed.value,
  choiceReviewButtonClickedYes: choiceReviewButtonClickedYes.value,
  choiceReviewButtonClickedNo: choiceReviewButtonClickedNo.value,
}));

api(`v1/reviewer/tracking`)
  .then(async (res) => {
    // console.log("fetch reviewers tracking:", res.data);
    choiceReviewButtonClickedYes.value = res.data.choiceReviewButtonClickedYes;
    choiceReviewButtonClickedNo.value = res.data.choiceReviewButtonClickedNo;
    reviewersWithStatusReviewed.value = res.data.reviewersWithStatusReviewed;
  })
  .catch((error) => {
    console.error("fetch reviewers error:", error);
    loading.value = false;
  });

api(`v1/review/`)
  .then(async (res) => {
    if (res.data && res.data.reviews.length > 0) {
      reviews.value = res.data.reviews.filter(
        (review) => review.reviewerId.status !== "archived"
      );
      //delay for testing
      // await new Promise((resolve) => setTimeout(resolve, 2000));
    }
    loading.value = false;
  })
  .catch((error) => {
    console.error("fetch reviews error:", error);
    loading.value = false;
  });

// analytics
const reviewCount = computed(() => reviews.value.length);
const positive = computed(
  () => reviews.value.filter((review) => review.rating > 3).length
);
const negative = computed(
  () => reviews.value.filter((review) => review.rating <= 3).length
);
const positivePercentage = computed(
  () => Math.round((positive.value / reviewCount.value) * 10000) / 100
);
const averageRating = computed(() => {
  const result =
    reviews.value.reduce((a, b) => a + b.rating, 0) / reviewCount.value;
  return Math.round(result * 100) / 100;
});
const highestRating = computed(() =>
  reviews.value.reduce((a, b) => (b.rating > a ? b.rating : a), 0)
);
const lowestRating = computed(() =>
  reviews.value.reduce(
    (a, b) => (b.rating < a ? b.rating : a),
    reviewCount.value ? 5 : "N/A"
  )
);
const averageComment = computed(
  () =>
    reviews.value.reduce((a, b) => a + b.comment.length, 0) / reviewCount.value
);
const longestComment = computed(() =>
  reviews.value.reduce(
    (a, b) => (b.comment.length > a ? b.comment.length : a),
    0
  )
);
const shortestComment = computed(() =>
  reviews.value.reduce(
    (a, b) => (b.comment.length < a ? b.comment.length : a),
    reviewCount.value ? 5 : "N/A"
  )
);

const possibleRatings = Array(6)
  .fill(0)
  .map((_, index) => index);

const analytics = [
  {
    name: "Review Positive % (> 3)",
    value: positivePercentage,
  },
  {
    name: "Reviews",
    value: reviewCount,
  },
  {
    name: "Positive Reviews (> 3)",
    value: positive,
  },
  {
    name: "Negative Reviews (3 or less)",
    value: negative,
  },
  {
    name: "Average Rating",
    value: averageRating,
  },
  {
    name: "Highest Rating",
    value: highestRating,
  },
  {
    name: "Lowest Rating",
    value: lowestRating,
  },
  {
    name: "Average Comment Length",
    value: averageComment,
  },
  {
    name: "Longest Comment",
    value: longestComment,
  },
  {
    name: "Shortest Comment",
    value: shortestComment,
  },
];

function generateFakeReviews(length) {
  const maxRating = 5; // Maximum rating value
  const maxCommentLength = 50; // Maximum comment length
  const currentDate = new Date();
  const pastDate = new Date(currentDate.getTime() - 30 * 24 * 60 * 60 * 1000);
  const fakeReviews = [];

  for (let i = 0; i < length; i++) {
    const rating = Math.floor(Math.random() * (maxRating + 1));
    const comment = generateRandomString(maxCommentLength);
    const randomTimestamp =
      pastDate.getTime() +
      Math.random() * (currentDate.getTime() - pastDate.getTime());
    const createdAt = new Date(randomTimestamp).toISOString();

    fakeReviews.push({ rating, comment, createdAt });
  }

  return fakeReviews;
}

function generateRandomString(length) {
  const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let randomString = "";
  const randomLength = Math.floor(Math.random() * length) + 1;
  for (let i = 0; i < randomLength; i++) {
    randomString += characters.charAt(
      Math.floor(Math.random() * characters.length)
    );
  }

  return randomString;
}

const fakeReviews = generateFakeReviews(50);
</script>
<style scoped>
.large-font-column {
  font-size: 28px;
}
</style>
